export default __webpack_public_path__ + "static/media/learose4-768w.a60b3d76.avif";